import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import { useWebsiteSettings } from "../../../store/api/useWebsiteSettings";
import { useTheme } from "../../../context/ThemeProvider";

export default function TermsAndCondition({
  embedded = false,
}: {
  embedded?: boolean;
}) {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const location = useLocation();
  const { data } = useWebsiteSettings();
  // @ts-ignore
  const { theme } = useTheme();

  const isStandalone =
    location.pathname == "/terms-and-condition" && !embedded;

  return (
    <div
      className={
        embedded
          ? "relative h-full min-h-0 w-full bg-primary"
          : `relative mx-auto flex min-h-[50rem] w-screen flex-col overflow-hidden bg-white ${
              isStandalone ? "h-screen pt-20" : "h-screen"
            }`
      }
    >
      {!isIframeLoaded && (
        <div className="absolute inset-0 z-10 grid place-content-center bg-primary">
          <ClipLoader
            color={theme == "dark" ? "white" : "black"}
            size={28}
          />
        </div>
      )}

      <iframe
        title="Terms and Conditions"
        srcDoc={data?.data?.terms_and_conditions}
        className={`h-full w-full border-0 ${
          isIframeLoaded ? "opacity-100" : "opacity-0"
        }`}
        sandbox="allow-same-origin allow-scripts allow-popups"
        onLoad={() => setIsIframeLoaded(true)}
      />
    </div>
  );
}
